import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material';
import { t } from '../../translations/i18n';
import { getRouteByPath, ROUTES } from '../../app/routes';
import WorkspaceVariablesManager from '../../managers/WorkspaceVariablesManager';
import { store } from '../../store/store';
import { IWorkspaceEnrichedVariable } from '../../models/IVariables';
import MikeButton from '../../shared-components/mike-button';
import { useNavigate } from 'react-router-dom';

type ConfirmDeleteDialogProps = {
  projectId: string;
  workspaceId: string;
  variable: IWorkspaceEnrichedVariable;
  open: boolean;
  onClose: (confirmed: boolean) => void;
};

/**
 * Shows a confimation dialog for deleting a variable and deletes the variable if user confirms
 * @param props
 *
 * Todo hevo confirm dialogs for all layer types (meshes, geometry and variables) are avery similar. We could maybe like make something more reusable.
 */
export const MmgConfirmDeleteVariableDialog = (props: ConfirmDeleteDialogProps) => {
  const navigate = useNavigate();
  const { open, onClose, variable, projectId, workspaceId } = props;

  if (!variable) {
    return;
  }

  const variableId = variable.id;

  const handleClose = () => {
    onClose(false);
  };

  const handleOk = () => {
    onVariableDelete();
    closeDialog(true);
  };

  const handleCancel = () => {
    closeDialog(false);
  };

  const closeDialog = (confirmed: boolean) => {
    onClose(confirmed);
  };

  const onVariableDelete = () => {
    return WorkspaceVariablesManager.deleteVariables(workspaceId, [variableId])
      .then(() => {
        const toast = {
          text: t('DELETED', 1, {
            thing: t('VARIABLE'),
          }),
        };
        store.dispatch({ type: 'toast/ADD/SUCCESS', toast });

        store.dispatch({
          type: 'workspace/variables/DELETE_SUCCESS',
          workspaceVariables: [variableId],
        });
        navigate(getRouteByPath(ROUTES.workspacePanel.path, { workspaceId, projectId }, ROUTES.workspace.path));  
      })
      .catch((error) => {
        const toast = {
          text: t('FAILED_TO', 1, { action: t('DELETE') }),
          operationId: error.operationId,
        };
        store.dispatch({ type: 'toast/ADD/ERROR', toast });
        throw error;
      });
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      id="confirm-delete-variable"
      aria-labelledby="delete-variable-dialog-title"
      aria-describedby="delete-variable-dialog-description"
    >
      <DialogTitle id="delete-variable-dialog-title">
        {t('VARIABLE_CONFIRM_DELETE_TITLE')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="delete-variable-dialog-description">
          {t('VARIABLE_CONFIRM_DELETE_TEXT', 1, {
            name: variable.name,
          })}{' '}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <MikeButton onClick={handleCancel} color="secondary" variant="contained">
          {t('CANCEL')}
        </MikeButton>
        <MikeButton onClick={handleOk} color="secondary" variant="contained" autoFocus>
          {t('DELETE')}
        </MikeButton>
      </DialogActions>
    </Dialog>
  );
};
